import { Injectable } from "@angular/core";
import { Horario } from "@tivic-team/manager-ts/dist/mob/entities/horario/horario.entity";
import { HorarioTableDTO } from "app/model/dtos/mob/horario-table.dto";
import { HorarioController } from "../../controllers/mob/horario.controller";
import { LoteHorariosDTO } from "../../model/dtos/mob/loteHorariosDTO";
import { ApiService } from "../api-service.interface";
import { LoaderService } from "../loader.service";
import { HorarioSearch } from "./horario.search";

@Injectable()
export class HorarioService implements ApiService<Horario> {
  constructor(private _horarioController: HorarioController, private _loaderService: LoaderService) {}

  find(search?: HorarioSearch): Promise<Horario[]> {
    this._loaderService.show();
    return this._horarioController.find((search && search.getFilters()) || null).finally(() => this._loaderService.hide());
  }

  get(...args: number[]): Promise<Horario> {
    throw new Error("Method not implemented.");
  }

  create(entity: Horario): Promise<Horario> {
    this._loaderService.show();
    return this._horarioController.create(entity).finally(() => this._loaderService.hide());
  }

  update(entity: Horario): Promise<Horario> {
    this._loaderService.show();
    return this._horarioController.update(entity).finally(() => this._loaderService.hide());
  }

  delete(cdHorario: number, cdTabelaHorario: number, cdLinha: number, cdRota: number, cdTrecho: number): Promise<Horario> {
    this._loaderService.show();
    return this._horarioController.delete(cdHorario, cdTabelaHorario, cdLinha, cdRota, cdTrecho).finally(() => this._loaderService.hide());
  }

  save(entity: Horario): Promise<Horario> {
    if (!entity.cdHorario) return this.create(entity);

    return this.update(entity);
  }

  async getHorarios(cdLinha: number, cdTabelaHorario: number): Promise<HorarioTableDTO[]> {
    this._loaderService.show();
    return this._horarioController
      .getHorarios(cdLinha, cdTabelaHorario)
      .finally(() => this._loaderService.hide());
  }

  async getHorariosRota(cdLinha: number, cdTabelaHorario: number, cdRota: number): Promise<any> {
    this._loaderService.show();
    return this._horarioController
      .getHorariosRota(cdLinha, cdTabelaHorario, cdRota)
      .finally(() => this._loaderService.hide());
  }

  async saveLote(loteHorariosDTO: LoteHorariosDTO): Promise<LoteHorariosDTO> {
    this._loaderService.show();
    if (loteHorariosDTO) {
      return this._horarioController.saveLote(loteHorariosDTO).finally(() => this._loaderService.hide());
    }
  }

  async saveGrupoHorarios(horario: Array<Horario>): Promise<Array<Horario>> {
    this._loaderService.show();
    if (horario) {
      return this._horarioController.saveGrupoHorarios(horario).finally(() => this._loaderService.hide());
    }
  }
}
